import brandEn from './brand/en.json';
import brandZhHant from './brand/zh-Hant.json';
import brandVi from './brand/vi.json';
import brandTh from './brand/th.json';

export default {
  en: brandEn,
  'zh-Hant': brandZhHant,
  vi: brandVi,
  th: brandTh,
};
